// extracted by mini-css-extract-plugin
export default {"portfolioBlock":"PortfolioBlock_portfolioBlock__opPxy"};